import React, { Component ,Fragment} from 'react';
import Breadcrumb from "../../common/breadcrumb"
import queryString from "query-string";
import { getObject, updateObject, packData, listItems  } from "../../api";
import { AvField, AvForm } from 'availity-reactstrap-validation';
import Editor from "../../common/quillEditor";
import { FlowDataEntry } from '../../common/flowDataEntry'

export class LandingPageEdit extends Component {
    constructor(props) {
        super(props)
        const value=queryString.parse(this.props.location.search);
        this.handleContentChange = this.handleContentChange.bind(this);
        this.handleHookChange = this.handleHookChange.bind(this);

        this.state = {
            loading: true,
            pid: value.pid,
            data: {},
        }
    }

    imageUrlUpdated = (event) => {       
        this.setState( {data: {...this.state.data, imageUrl: event.target.value}});
    }

    onValidSubmit = (event, values) => {
        const formData = new FormData(document.getElementById('mainForm'));
        packData(formData, this.state.data, values)
        this.onSaveLandingPage(formData);
    };
    
    onInvalidSubmit = (event, errors, values) => {
        this.setState({errors, values});
    };

    handleContentChange = (value) => {
        this.setState({
            data: { ...this.state.data, content: value }
        });
    }

    handleHookChange = (value) => {
        this.setState({
            data: { ...this.state.data, hook: value }
        });
    }

    onSaveLandingPage = (values) => {
        updateObject('landingPage', values, this.state.pid).then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
            } else {
                this.setState({pid: d2._id});
                this.loadLandingPage();
            }
        });
    };

    loadLandingPage = () => {
        this.setState({ loading: true});
        if (this.state.pid) {
            getObject('landingPage', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ 
                        data: d2.landingPage, 
                        loading: false
                    });                    
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadLandingPage();        
    }

    render() {
        const defaultValues = this.state.data;
        
        if (this.state.loading) { return null; }
        else {
            setTimeout(function() {
                document.querySelector(".loader-wrapper").style = "display: none";
            }, 100);       
        return (
            <Fragment>
                <Breadcrumb title="Edit LandingPage" parents={[{name: "LandingPage List", url: "/admin/landingPage/list"}]}/>
                
                <AvForm id="mainForm" className="needs-validation" onValidSubmit={this.onValidSubmit} onInvalidSubmit={this.onInvalidSubmit} model={defaultValues}>
                    <FlowDataEntry >
                        <Fragment>                    
                            <AvField label="Title" grid={{xs: 10}} name="title" id="title" type="text" />
                            <AvField label="Tags" grid={{xs: 10}} name="tags" id="tags" type="text" value={listItems(this.state.data.tags)}/>
                            <AvField label="Permissions" grid={{xs: 10}} name="permTags" id="permTags" type="text" value={listItems(this.state.data.permTags)}/>
                            <AvField label="Published" grid={{xs: 10}} name="publishedAt" id="publishedAt" type="text" />
                            <AvField label="Inactive" grid={{xs: 10}} name="inactiveDate" id="inactiveDate" type="text" />
                        </Fragment>

                        <Editor 
                            content={defaultValues.content}
                            onContentChange={this.handleContentChange}
                        />
                        
                        <Fragment>                    
                            <AvField label="Image Url" grid={{xs: 10}} name="imageUrl" id="imageUrl" type="text" onBlur={(e) => this.imageUrlUpdated(e)}/>
                            <div className="row">
                                <div className="col-sm-2">
                                </div>
                                <div className="col-sm-10">  
                                    <img src={defaultValues.imageUrl}  style={{border:"1px solid #021a40", height:200}} alt="" />
                                </div>
                            </div>
                        </Fragment>
                    </FlowDataEntry >
                </AvForm>   
            </Fragment>
        )
    }
}
}

export default LandingPageEdit
